<template>
  <div>
    <header>
      <Header :noAuth="noAuth" msg="Header" />
      <div class="searchbar" v-if="foodType !== 'AllShops'">
        <div class="container">
          <CityDistrictSelector
            :initialCity="cityFilter"
            :initialDistrict="districtFilter"
            :isGpsActive="isGpsActive"
            :parentPermission="locationPermission"
            :parentIsLocating="isLocating"
            :shopAddresses="allShopAddresses"
            @change="onAddressChange"
            @gps-search="onGpsSearch"
          />
        </div>
      </div>
      <!-- 定位權限說明按鈕（當拒絕且未顯示說明時顯示） -->
        <div v-if="locationPermission === 'denied' && foodType !== 'AllShops' && !showGeolocationGuide" class="geolocation-alert-inline">
          <span>尚未定位，點擊查看</span>
            <button @click="showGeolocationGuide = true" class="btn-show-guide-link">
              如何開啟定位
            </button>
        </div>
    </header>

    <!-- 定位權限說明（當拒絕時顯示） -->
    <GeolocationGuide
      v-if="showGeolocationGuide"
      @close="showGeolocationGuide = false"
      @retry-success="handleRetrySuccess"
      @retry-failed="handleRetryFailed"
      @use-manual-selection="handleUseManualSelection"
    />
    <!-- 視圖切換按鈕 -->
    <div v-if="showViewMode" class="view-mode-toggle">
      <div class="container">
        <div class="toggle-buttons">
          <button
            :class="['toggle-btn', viewMode === 'map' ? 'active' : '']"
            @click="viewMode = 'map'"
          >
            <span class="icon-map"></span>
            地圖
          </button>
          <button
            :class="['toggle-btn', viewMode === 'list' ? 'active' : '']"
            @click="viewMode = 'list'"
          >
            <span class="icon-list"></span>
            列表
          </button>
        </div>
      </div>
    </div>
    

    <main>
      <Banners />
      <nav v-if="foodType !== 'AllShops'" class="tabs store" :style="{ top: showViewMode ? '96px' : '39px' }">
        <div class="container">
          <a
            href="#"
            v-on:click="selectedCategory = 'all'"
            :class="[selectedCategory === 'all' ? 'current' : '']"
            >全部</a
          >
          <a
            href="#"
            v-on:click="selectedCategory = 'history'"
            :class="[selectedCategory === 'history' ? 'current' : '']"
            >曾點過</a
          >
        </div>
      </nav>
      <div v-if="loading" class="loading_area flex_center">
        <div class="loader"></div>
        <div>loading..</div>
      </div>

      <!-- 地圖檢視 -->
      <!-- 優化：v-if 延遲載入（第一次點擊才創建）+ v-show 控制顯示（創建後不銷毀） -->
      <div v-if="mapActivated" v-show="!loading && viewMode === 'map'" style="position: relative;">
        <ShopMap
          :shops="filteredShops || []"
          :center="districtCenter"
          :zoom="mapZoom"
          @open-shop="openShop"
          @shop-selected="onShopSelected"
        />

        <!-- 無店家提示 Overlay -->
        <div
          v-if="!filteredShops || !filteredShops.length"
          class="no-shops-overlay"
        >
          <div class="no-shops-message">
            <div class="icon-notfound"></div>
            <div class="message-text">
              <b>{{ noShopsMessage }}</b>
            </div>
          </div>
        </div>
      </div>

      <!-- 列表檢視 -->
      <div v-show="!loading && viewMode === 'list'" class="storelist image_s container flex_top flex_wrap">
        <div v-if="!filteredShops || !filteredShops.length" class="no-shops-message-list">
          <div class="icon-notfound"></div>
          <div class="message-text">
            <b>{{ noShopsMessage }}</b>
          </div>
        </div>
        <a
          v-for="(shop, index) in filteredShops"
          :key="index"
          class="flex_center flex_wrap"
          v-on:click="openShop(shop.id)"
        >
          <div class="cover">
            <img :src="shop.image ? shop.image : defaultImage" />
            <div v-if="!shop.isEnabled" class="cover_mask flex_center">
              暫不供應
            </div>
            <!-- 暫不供應的圖片加遮罩 -->
          </div>
          <div class="info">
            <div class="name">{{ shop.name }}
            </div>
            <div class="add">
              {{ shop.address }}
              <span v-show="foodType !== 'AllShops' && isGpsSearchActive" class="km">
                ({{
                  (shop.distance !== null && shop.distance !== undefined) ? shop.distance.toFixed(2) + " km" : ""
                }})
              </span>
            </div>
          </div>
          <div class="focus">
            <!-- <div class="comment"><i class="icon-star"></i> 4.5</div> -->
            <div
              v-if="shop.portalLinkType !== 'line'"
              :class="['status', shop.isEnabled ? '' : 'stop-open']"
            >
              {{ shop.isEnabled ? "" : "暫不供應" }}
            </div>
            <!-- <time
              v-if="
                foodType !== 'AllShops' &&
                  shop.isDelivery &&
                  shop.portalLinkType !== 'line'
              "
              :class="['delivery', shop.isEnabled ? '' : 'visible_hide']"
              >外送{{ shop.dWaitingHumanTime
              }}{{ shop.dWaitingHumanUnit }}</time
            >
            <time
              v-if="
                foodType !== 'AllShops' &&
                  shop.isTakeout &&
                  shop.portalLinkType !== 'line'
              "
              :class="['self', shop.isEnabled ? '' : 'visible_hide']"
              >自取{{ shop.waitingHumanTime }}{{ shop.waitingHumanUnit }}</time
            > -->
            <!-- <time
              v-if="
                foodType !== 'AllShops' &&
                  shop.isDelivery &&
                  shop.portalLinkType !== 'line'
              "
              :class="['delivery', shop.isEnabled ? '' : 'visible_hide']"
              >外送</time
            >
            <time
              v-if="
                foodType !== 'AllShops' &&
                  shop.isTakeout &&
                  shop.portalLinkType !== 'line'
              "
              :class="['self', shop.isEnabled ? '' : 'visible_hide']"
              >自取</time
            ></time> -->
          </div>
          <div class="iconbar">
            <div class="pick">
              <i v-if="shop.isDelivery" class="icon_delivery">送</i>
              <i v-if="shop.isTakeout" class="icon_self">自</i>
              <i v-if="shop.isEatIn" class="icon_inside">內</i>
            </div>
            <div class="pay">
              <i
                v-if="shop.isMobilePayment && shop.payMethods.linepay"
                class="icon_linepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.googlepay"
                class="icon_googlepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.applepay"
                class="icon_applepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.credit"
                class="icon_creditcard"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.easywallet"
                class="icon_easywallet"
              ></i>
               <i
                  v-if="shop.isMobilePayment && shop.payMethods.taiwanpay"
                  class="icon_taiwanpay"
                ></i>
                  <i
                  v-if="shop.isMobilePayment && shop.payMethods.jkopay"
                  class="icon_jkopay"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.icashpay"
                  class="icon_icash"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.pxpay"
                  class="icon_pxpay"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.pxpayplus"
                  class="icon_pxpay"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.pluspay"
                  class="icon_pluspay"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.twqr"
                  class="icon_twqr"
                ></i>
                <i
                  v-if="shop.isMobilePayment && shop.payMethods.aftee"
                  class="icon_aftee"
                ></i>
              <i v-if="shop.isCash" class="icon_cash"></i>
            </div>
          </div>
        </a>
      </div>
      <!-- END .storelist.image_s -->
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Banners from "@/components/Banners.vue";
import CityDistrictSelector from "@/components/CityDistrictSelector.vue";
import GeolocationGuide from "@/components/GeolocationGuide.vue";
import ShopMap from "@/components/ShopMap.vue";
import { authService } from "@/services/auth";
import apis from "@/services/apis";
import moment from "moment";
import { mockShops } from "@/data/mockShops";
import shopFilterMixin from '@/mixins/shopFilterMixin';
import geolocationMixin from "@/mixins/geolocationMixin";

import { Base64 } from "js-base64";

import Vue from "vue";
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

export default {
  name: "Togo",
  components: {
    Header,
    Banners,
    CityDistrictSelector,
    GeolocationGuide,
    ShopMap,
  },
  mixins: [shopFilterMixin, geolocationMixin],
  data() {
    return {
      showViewMode: false,
      loading: false,
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      selectedCategory: "all",
      shops: {
        all: [],
        history: [],
      },
      inputAddr: "",
      mapZoom: 13,
      cityFilter: "",
      districtFilter: "",
      selectedDistrictCenter: null, // 儲存從 CityDistrictSelector 傳來的行政區中心經緯度
      viewMode: 'list', // 'map': 地圖檢視, 'list': 列表檢視
      mapActivated: false, // 用於延遲載入地圖（第一次點擊才創建）
      isGpsSearchActive: false, // 追蹤是否為 GPS 搜尋觸發
    };
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    cachedAddress() {
      if (!localStorage.getItem("address")) return null;
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
    noAuth() {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        return "true";
      }
      return "false";
    },
    allShopAddresses() {
      return (this.shops.all || []).map(s => s.address).filter(Boolean);
    },
    noShopsMessage() {
      // 根據不同的篩選條件顯示不同的訊息
      if (this.selectedCategory === 'history') {
        return '您尚未點過任何店家';
      }

      if (this.userCoords) {
        return '您的位置附近目前沒有店家';
      }

      if (this.cityFilter && this.districtFilter) {
        return `${this.cityFilter}${this.districtFilter}目前沒有店家`;
      }

      if (this.cityFilter) {
        return `${this.cityFilter}目前沒有店家`;
      }

      return '目前沒有店家';
    },
    filteredShops() {
      // 根據 cityFilter 和 districtFilter 過濾當前分類的商店
      const currentShops = this.shops[this.selectedCategory] || [];

      // 如果是 GPS 搜尋觸發，使用 applyGeolocationFilter
      if (this.isGpsSearchActive && this.userCoords) {
        return this.applyGeolocationFilter(this.userCoords);
      }

      // 其他情況使用 applyMixedFilter
      const centerPoint = this.districtCenter;

      return this.applyMixedFilter(currentShops, {
        city: this.cityFilter,
        district: this.districtFilter,
        coords: this.userCoords || centerPoint,
        radius: (this.foodType === 'AllShops' || !this.cityFilter) ? 0 : this.filterRadius,
        limit: 0,
        mode: this.filterMode
      });
    },
    districtCenter() {
      if (this.selectedDistrictCenter && this.selectedDistrictCenter.lat && this.selectedDistrictCenter.lng) {
        return this.selectedDistrictCenter;
      }
      return this.calculateShopsCenter();
    },
  },
  methods: {
    applyGeolocationFilter(coords) {
      console.log('Togo: Applying geolocation filter:', coords);

      // 啟用 GPS 搜尋模式（無論是手動還是自動定位）
      this.isGpsSearchActive = true;

      // 使用 mixin 的距離篩選方法
      const nearbyShops = this.filterByDistance(coords, {
        limit: this.foodType === 'AllShops' ? 0 : 60,        // 顯示前 60 間最近的店家
        maxRadius: 0      // 關閉半徑過濾，顯示最近的
      });

      console.log(`Togo: Found ${nearbyShops.length} nearby shops`);

      // 更新地圖中心點
      if (this.$refs.shopMap) {
        this.$refs.shopMap.setCenter(coords);
      }
      return nearbyShops;
    },
    calculateShopsCenter() {
      // 取得當前分類的商店列表
      const currentShops = this.shops[this.selectedCategory] || [];

      if (currentShops.length === 0) {
        // 沒有商店時，返回台北市中心
        return { lat: 25.0330, lng: 121.5654 };
      }

      let filteredShops = currentShops;

      // 逐步過濾 1: 縣市
      if (this.cityFilter) {
        filteredShops = filteredShops.filter(shop =>
          shop.address && shop.address.includes(this.cityFilter)
        );
      }

      // 逐步過濾 2: 行政區
      if (this.districtFilter) {
        filteredShops = filteredShops.filter(shop =>
          shop.address && shop.address.includes(this.districtFilter)
        );
      }

      // 過濾出有經緯度的商店
      const shopsWithCoords = filteredShops.filter(shop => shop.lat && shop.lng);

      if (shopsWithCoords.length === 0) {
        // 若過濾後無座標，則嘗試對「過濾前」有座標的商店取平均
        const allShopsWithCoords = currentShops.filter(shop => shop.lat && shop.lng);
        if (allShopsWithCoords.length === 0) {
          return { lat: 25.0330, lng: 121.5654 };
        }
        
        const avgLat = allShopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lat), 0) / allShopsWithCoords.length;
        const avgLng = allShopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lng), 0) / allShopsWithCoords.length;
        return { lat: avgLat, lng: avgLng };
      }

      // 計算符合條件店家的平均經緯度
      const avgLat = shopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lat), 0) / shopsWithCoords.length;
      const avgLng = shopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lng), 0) / shopsWithCoords.length;

      return { lat: avgLat, lng: avgLng };
    },
    openShop(shopId) {
      if (this.foodType === "Togo") {
        this.$router.push({
          path: `/togo/${shopId}`,
          query: this.$router.currentRoute.query,
        });
      } else if (this.foodType === "Foods") {
        this.$router.push({
          path: `/foods/${shopId}`,
          query: this.$router.currentRoute.query,
        });
      } else if (this.foodType === "AllShops") {
        this.$router.push({
          path: `/all-shops/${shopId}`,
          query: this.$router.currentRoute.query,
        });
      }
    },
    onAddressChange(data) {
      // 當縣市或行政區改變時
      const { city, district, lat, lng } = data;

      // 清除 GPS 定位點（手動選擇地址時不再使用 GPS 位置）
      this.clearDistanceFilter();

      // 清除保存的地圖狀態（使用者主動更改篩選條件）
      localStorage.removeItem('mapState');

      // 停用 GPS 搜尋模式，切換為地址篩選模式
      this.isGpsSearchActive = false;
      this.filterMode = 'address';

      // 更新篩選條件
      this.cityFilter = city || "";
      this.districtFilter = district || "";

      // 儲存從 CityDistrictSelector 傳來的行政區中心經緯度
      if (lat && lng) {
        this.selectedDistrictCenter = { lat, lng };
      } else {
        this.selectedDistrictCenter = null;
      }

      // 保存到 localStorage，以便返回時恢復（包含經緯度）
      if (city || district) {
        localStorage.setItem('cityDistrictFilter', JSON.stringify({
          city: this.cityFilter,
          district: this.districtFilter,
          lat: lat || null,
          lng: lng || null
        }));
      } else {
        localStorage.removeItem('cityDistrictFilter');
      }

      if (city && district) {
        // 有選擇特定縣市和行政區
        this.inputAddr = `${city}${district}`;
        this.mapZoom = 14;
        // filteredShops 和 districtCenter 會自動根據 cityFilter 和 districtFilter 更新
      } else if (city && !district) {
        // 只選擇縣市，顯示該縣市所有店家
        this.inputAddr = city;
        this.mapZoom = 12;
        // filteredShops 會自動過濾
      } else {
        // 選擇「全部縣市」
        this.inputAddr = "";
        this.mapZoom = 11;
        // filteredShops 會返回所有店家
      }
    },
    onShopSelected(shop) {
      console.log('Selected shop:', shop);
      // 可以在這裡處理商店選擇事件
    },
    onGpsSearch(data) {
      // 當使用 GPS 定位時
      const { lat, lng } = data;

      if (lat && lng) {
        const coords = { lat: parseFloat(lat), lng: parseFloat(lng) };
        this.mapZoom = 15;

        // 定位後清除選取的縣市行政區與快取
        this.cityFilter = "";
        this.districtFilter = "";
        this.selectedDistrictCenter = null;
        this.inputAddr = "";
        localStorage.removeItem('cityDistrictFilter');

        // 切換為距離篩選模式，觸發定位篩選與狀態更新
        this.filterMode = 'radius';
        this.updateGeolocation(coords);
      }
    },
    /**
     * 重新定位成功
     */
    handleRetrySuccess() {
      console.log('Retry geolocation success');
      this.showGeolocationGuide = false;
    },

    /**
     * 重新定位失敗
     */
    handleRetryFailed(error) {
      console.error('Retry geolocation failed:', error);
      // 保持顯示說明彈窗，讓用戶可以選擇手動選擇
    },

    /**
     * 使用者選擇手動選擇縣市
     */
    handleUseManualSelection() {
      console.log('User chose manual selection');
      this.showGeolocationGuide = false;
    },
    setAddressInput(addrObj) {
      if (!addrObj) return;

      if (addrObj.mainText && addrObj.secondaryText) {
        this.inputAddr = `${addrObj.mainText ? addrObj.mainText : ""}${
          addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        }`;
      } else if (addrObj.address) {
        this.inputAddr = addrObj.address;
      }

      // 縣市和行政區篩選條件會從 localStorage 的 cityDistrictFilter 恢復
    },
    getAddress() {
      let self = this;

      // 先取得所有店家
      self.getPortalShops();

      if (this.footType === "AllShops") {
        return;
      }

      return apis
        .getUserProfile(self.userId)
        .then(function(responses) {
          if (responses && responses.address) {
            localStorage.setItem(
              "address",
              Base64.encode(
                JSON.stringify({
                  address: responses.address,
                  mainText: responses.mainText,
                  secondaryText: responses.secondaryText,
                  placeId: responses.placeId,
                  aptSuiteFloor: responses.aptSuiteFloor,
                })
              )
            );
            self.setAddressInput(responses);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getHistoryShops() {
      let self = this;
      return fetch(
        `${process.env.VUE_APP_APIHOST}/apis/history-shops?user_id=${self.userId}&p=${self.$router.currentRoute.query.p}`
      )
        .then((res) => res.json())
        .then(function(responses) {
          let hmap = {};

          for (let i = 0; i < responses.length; ++i) {
            if (responses[i]) hmap[responses[i].shopId] = true;
          }

          self.shops.history = [];
          for (let j = 0; j < self.shops.all.length; ++j) {
            if (self.shops.all[j].id && hmap[self.shops.all[j].id.toString()])
              self.shops.history.push(self.shops.all[j]);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getPortalShops() {
      let self = this;
      let options = {};
      if (this.pickupfilter === "Togo") {
        options = { is_to_go: true };
      }

      // 使用假資料進行測試
      if (process.env.VUE_APP_USE_MOCK_DATA === 'true') {
        setTimeout(() => {
          self.processMockShops(mockShops);
          self.loading = false;
        }, 500);
        return Promise.resolve();
      }

      return apis
        .getPortalShops(this.$router.currentRoute.query.p, "catering", options)
        .then((response) => {
          let shops = [];
          for (let i = 0; i < response.length; ++i) {
            if (!response[i]) continue;

            response[i].waitingTime = parseInt(response[i].toGoWaitingTime ? response[i].toGoWaitingTime : response[i].waitingTime, 10);
            moment.relativeTimeThreshold("m"); //=> 22 (current value)
            moment.relativeTimeThreshold("m", 180); // (set new value to 24 (三小時內統一都用分鐘顯示)
            moment.relativeTimeThreshold("h"); //=> 22 (current value)
            moment.relativeTimeThreshold("h", 24); // (set new value to 24
            let waitingStr = moment
              .duration(response[i].waitingTime, "minutes")
              .locale("zh-TW")
              .humanize();
            let ss = waitingStr.split(" ");
            response[i].waitingHumanTime = ss[0];
            response[i].waitingHumanUnit = ss[1];

            // if delivery
            if (response[i].isDelivery) {
              response[i].deliveryWaitingTime = parseInt(response[i].deliveryWaitingTime ? response[i].deliveryWaitingTime : response[i].waitingTime, 10);
              let waitingStr = moment
                .duration(response[i].deliveryWaitingTime + 30, "minutes")
                .locale("zh-TW")
                .humanize();
              let ss2 = waitingStr.split(" ");
              response[i].dWaitingHumanTime = ss2[0];
              response[i].dWaitingHumanUnit = ss2[1];
            }

            response[i].payMethods = {
              linepay: true,
              applepay: true,
              googlepay: true,
              credit: true,
              easywallet: false,
              jkopay: false,
              taiwanpay: false
            };
            if (
              response[i].isMobilePayment &&
              response[i].paymentOptions &&
              response[i].paymentOptions.methods
            ) {
              // 有限制顯示的支付方式
              response[i].payMethods = {};

              for (
                let p = 0;
                p < response[i].paymentOptions.methods.length;
                ++p
              ) {
                response[i].payMethods[
                  response[i].paymentOptions.methods[p]
                ] = true;
              }
            }
            // if (response[i].distance < response[i].maxDistance) {
            //   shops.push(response[i]);
            // }
            shops.push(response[i]);
          }
          self.shops.all = shops;
          self.getHistoryShops();
          self.loading = false;
        })
        .catch((e) => {
          console.log("default shops failed " + e.stack);
        });
    },
    processMockShops(shopsData) {
      // 處理假資料
      let shops = [];
      for (let i = 0; i < shopsData.length; ++i) {
        if (!shopsData[i]) continue;

        shopsData[i].waitingTime = parseInt(shopsData[i].toGoWaitingTime ? shopsData[i].toGoWaitingTime : shopsData[i].waitingTime, 10);
        moment.relativeTimeThreshold("m", 180);
        moment.relativeTimeThreshold("h", 24);
        let waitingStr = moment
          .duration(shopsData[i].waitingTime, "minutes")
          .locale("zh-TW")
          .humanize();
        let ss = waitingStr.split(" ");
        shopsData[i].waitingHumanTime = ss[0];
        shopsData[i].waitingHumanUnit = ss[1];

        if (shopsData[i].isDelivery) {
          shopsData[i].deliveryWaitingTime = parseInt(shopsData[i].deliveryWaitingTime ? shopsData[i].deliveryWaitingTime : shopsData[i].waitingTime, 10);
          let waitingStr = moment
            .duration(shopsData[i].deliveryWaitingTime + 30, "minutes")
            .locale("zh-TW")
            .humanize();
          let ss2 = waitingStr.split(" ");
          shopsData[i].dWaitingHumanTime = ss2[0];
          shopsData[i].dWaitingHumanUnit = ss2[1];
        }

        shopsData[i].payMethods = {
          linepay: true,
          applepay: true,
          googlepay: true,
          credit: true,
          easywallet: false,
          jkopay: false,
          taiwanpay: false
        };

        if (
          shopsData[i].isMobilePayment &&
          shopsData[i].paymentOptions &&
          shopsData[i].paymentOptions.methods
        ) {
          shopsData[i].payMethods = {};
          for (let p = 0; p < shopsData[i].paymentOptions.methods.length; ++p) {
            shopsData[i].payMethods[shopsData[i].paymentOptions.methods[p]] = true;
          }
        }
        shops.push(shopsData[i]);
      }
      this.shops.all = shops;
      this.getHistoryShops();
    },
  },
  mounted() {
    // 恢復縣市行政區篩選條件
    const savedFilters = localStorage.getItem('cityDistrictFilter');
    if (savedFilters) {
      try {
        const filters = JSON.parse(savedFilters);
        this.filterMode = 'address';
        this.cityFilter = filters.city || '';
        this.districtFilter = filters.district || '';

        // 恢復行政區中心經緯度
        if (filters.lat && filters.lng) {
          this.selectedDistrictCenter = { lat: filters.lat, lng: filters.lng };
        }

        // 更新顯示的地址和縮放級別
        if (filters.city && filters.district) {
          this.inputAddr = `${filters.city}${filters.district}`;
          this.mapZoom = 14;
        } else if (filters.city) {
          this.inputAddr = filters.city;
          this.mapZoom = 12;
        }
      } catch (e) {
        console.error('Failed to restore filters:', e);
      }
    } else {
      // 如果沒有縣市篩選，嘗試恢復 GPS 定位（距離篩選模式）
      this.filterMode = 'radius';
      this.autoGeolocation()
      // const savedUserLocation = this.getUserLocation();
      // if (savedUserLocation) {
      //   this.applyGeolocationFilter(savedUserLocation);
      // } 
    }

    // 恢復視圖模式
    // const savedViewMode = localStorage.getItem('viewMode');
    // if (savedViewMode && (savedViewMode === 'map' || savedViewMode === 'list')) {
    //   this.viewMode = savedViewMode;
    // }
    
    this.subscription = authService.getUserId().subscribe((userId) => {
      console.log("get the sub user id " + JSON.stringify(userId));
      // 訂閱到 userId 後，如果有 cachedAddress，設置地址顯示和過濾條件
      if (this.cachedAddress) {
        this.setAddressInput(this.cachedAddress);
      }
    });

    // 如果使用假資料，直接載入
    if (process.env.VUE_APP_USE_MOCK_DATA === 'true') {
      this.processMockShops(mockShops);
      if (this.cachedAddress) {
        this.setAddressInput(this.cachedAddress);
      }
    } else {
      // 總是調用 getAddress()，它會負責獲取店家和設置地址
      this.getAddress();
    }
  },
  props: {
    pickupfilter: String,
    foodType: String,
  },
  watch: {
    viewMode(newValue) {
      // 當 viewMode 改變時，保存到 localStorage
      localStorage.setItem('viewMode', newValue);

      // 當切換到地圖模式時，啟用地圖（第一次才會創建）
      if (newValue === 'map' && !this.mapActivated) {
        this.mapActivated = true;
      }
    }
    // 註：不需要監聽 shops.all，因為 filteredShops computed property 會自動響應 shops 的變化
  },
  beforeDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  },
};
</script>
<style scoped>
.banner {
  width: 1200px;
  max-width: 100%;
  margin: 10px auto 20px auto;
}
.searchbar .searchbar_box .loader {
  display: block;
}

/* 無店家 Overlay 樣式 */
.no-shops-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: none;
}

.no-shops-message {
  text-align: center;
  padding: 30px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}

.no-shops-message .icon-notfound {
  margin-bottom: 15px;
}

.no-shops-message .message-text {
  font-size: 16px;
  color: #333;
}

.no-shops-message .message-text b {
  font-weight: 600;
}

/* 列表視圖無店家提示 */
.no-shops-message-list {
  width: 100%;
  text-align: center;
  padding: 60px 30px;
}

.no-shops-message-list .icon-notfound {
  margin-bottom: 15px;
}

.no-shops-message-list .message-text {
  font-size: 16px;
  color: #333;
}

.no-shops-message-list .message-text b {
  font-weight: 600;
}

/* 視圖切換按鈕樣式 */
.view-mode-toggle {
  position: sticky;
  top: 39px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 0;
  z-index: 10;
}

.view-mode-toggle .toggle-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.view-mode-toggle .toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: 2px solid #ddd;
  background: #fff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.view-mode-toggle .toggle-btn:hover {
  border-color: #999;
  color: #333;
}

.view-mode-toggle .toggle-btn.active {
  border-color: #4CAF50;
  background: #4CAF50;
  color: #fff;
}

.view-mode-toggle .toggle-btn .icon-map::before,
.view-mode-toggle .toggle-btn .icon-list::before {
  font-size: 16px;
}

/* 簡單的圖標樣式（如果沒有現成的圖標） */
.view-mode-toggle .toggle-btn .icon-map::before {
  content: '🗺️';
}

.view-mode-toggle .toggle-btn .icon-list::before {
  content: '📋';
}

/* 調整 nav.tabs 的固定位置，避免與視圖切換按鈕重疊 */
nav.tabs.store {
  top: 96px;
}

.geolocation-alert-inline {
  margin-top: 8px;
  font-size: 13px;
  color: #856404;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-show-guide-link {
  background: none;
  border: none;
  padding: 0;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
}
</style>
<style>
/* 確保 header 的 z-index 高於視圖切換按鈕 */
header {
  z-index: 20;
}

/* 確保下拉選單的 z-index 高於視圖切換按鈕 */
.searchbar .autocomplete {
  z-index: 100;
}
</style>
